import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";

export const ParticipationTrackerListItemSkeleton = ({
  widthPercentage = 0,
}: {
  widthPercentage?: number;
}) => (
  <Stack
    align="start"
    gap={2}
    className="w-full border-b border-line py-3 last:border-b-0"
  >
    <Skeleton className="h-4 w-32" />
    <Stack
      className="w-full"
      gap={4}
      direction="row"
      align="center"
      justify="between"
    >
      <Skeleton className="h-2" style={{ width: `${widthPercentage}%` }} />
      <Skeleton className="h-4 w-10" />
    </Stack>
  </Stack>
);
